export { Step7Generate as default } from './RemainingSteps';